import {persistedCanvasImageId} from './canvas-run-recovery';
type ImageRow={id?:number|string;clientId?:string|null;client_id?:string|null;variantOfImageId?:number|string|null;variant_of_image_id?:number|string|null};
/** Resolve database foreign keys to canvas identities regardless of row order. */
export function canvasSourceAssociations(rows:readonly ImageRow[]):Map<string,string>{
 const byDatabaseId=new Map(rows.filter(row=>row.id!=null&&persistedCanvasImageId(row)).map(row=>[String(row.id),persistedCanvasImageId(row)]));
 const sources=new Map<string,string>();
 for(const row of rows){
  const clientId=persistedCanvasImageId(row);
  const parent=row.variantOfImageId??row.variant_of_image_id;
  const source=parent!=null?byDatabaseId.get(String(parent)):undefined;
  if(clientId&&source&&clientId!==source)sources.set(clientId,source);
 }
 return sources;
}
